import React, {useEffect, useRef, useState} from "react"
import { Helmet } from 'react-helmet-async';
import Header from "../header/Header";
import About from "../about/About";
import Experience from "../experience/Experience";
import Services from "../services/Services";
import Portfolio from "../portfolio/Portfolio";
import WorkProcess from "../workProcess/WorkProcess";
import Blog from "../blog/Blog";
import Faq from "../faq/Faq";
import Contact from "../contact/Contact";

const MainPage = ({setActiveNav}) => {
    const [observer, setObserver] = useState()
    const aboutRef = useRef(null)
    const servicesRef = useRef(null)
    const portfolioRef = useRef(null)
    const stepsRef = useRef(null)
    const blogRef = useRef(null)
    const faqRef = useRef(null)

    const onVisible = (entry) => {
        switch (entry.target.id) {
            case 'header':
                setActiveNav('#')
                break
            case 'about_me':
                setActiveNav('#about')
                break
            case 'services':
                setActiveNav('#services')
                break
            case 'portfolio':
                setActiveNav('#portfolio')
                break
            case 'steps':
                setActiveNav('#steps')
                break
            case 'blog_swiper':
                setActiveNav('#blog')
                break
            case 'faq':
                setActiveNav('#faq')
                break
            case 'contact':
                setActiveNav('#contact')
                break
            default:
                return
        }
    }

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    onVisible(entry)
                }
            })
            }, {threshold: 0.4})
        setObserver(observer)

        return () => {
            observer.disconnect()
        }
    }, [])

    return (
        <>
            <Helmet>
                <title>Architectural Sketches & 2D or 3D Plans & Landscape — Yana</title>
                <meta name="description" content="Presentation-ready interior/exterior sketches, 2D and 3D colored plans, Landscape, fast turnaround, easy revisions." />
                <meta property="og:title" content="Architectural Sketches & 2D or 3D Plans & Landscape" />
                <meta property="og:description" content="For architects & interior designers. Fast, realistic, on-brief." />
                <meta property="og:image" content="https://www.artdesignyana.com/og-home.jpg" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Header setActiveNav={setActiveNav} observer={observer}/>
            <About observer={observer} sectionRef={aboutRef}/>
            <Experience/>
            <Services observer={observer} sectionRef={servicesRef}/>
            <Portfolio observer={observer} sectionRef={portfolioRef}/>
            {/*Component temporary disabled*/}
            {/*<Testimonials/>*/}
            <WorkProcess observer={observer} sectionRef={stepsRef}/>
            <Blog observer={observer} sectionRef={blogRef}/>
            <Faq observer={observer} sectionRef={faqRef}/>
            <Contact observer={observer}/>
        </>
    )
}

export default MainPage
